import React from 'react';
import LoaderEcg from './LoaderEcg';
import InsightLogoSvg from './InsightLogoSvg';

const FullPageLoader: React.FC = () => {
  return (
    <div className="full-page-loader flex items-center justify-center" aria-busy="true" aria-live="polite" role="status" aria-label="Loading data">
      <div className="grid-loading-shell flex flex-col items-center justify-center gap-2">
        <InsightLogoSvg className="grid-loading-logo" />
        <div className="grid-loading-progress" aria-hidden="true">
          <LoaderEcg />
        </div>
        <span className="grid-loading-text" aria-hidden="true">
          Loading
          <span className="grid-loading-text-dots">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </span>
        <span className="sr-only">Loading data</span>
      </div>
    </div>
  );
};

export default FullPageLoader;
